/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { SelectionMode } from "abreact/incubator/ui/SharedTypes";
import { AbList as AbListImpl } from "abreact/input/AbList";
import { AbSelectionMode } from "absdk/commons/ui/input/AbSelectionMode";
import { AB_ITEM_SEPARATOR } from "absdk/commons/utils/collection/AbItemSeparator";
import * as React from "react";

/**
 * The common properties of an AbList.
 */

/**
 * The properties for an AbList.
 */

/**
 * A component that can show a list of items.
 *
 * [[include:absdk/commons/ui/input/AbList.md]]
 */
export function AbList(props) {
  return /*#__PURE__*/React.createElement(AbListImpl, mapProps(props));
}
(function (_AbList) {
  const SEPARATOR = _AbList.SEPARATOR = AB_ITEM_SEPARATOR;
})(AbList || (AbList = {}));
const mapProps = props => {
  switch (props.selectionMode) {
    case undefined:
    case AbSelectionMode.NONE:
      return {
        ...props,
        selectionMode: SelectionMode.NONE
      };
    case AbSelectionMode.SINGLE:
      return {
        ...props,
        selectionMode: SelectionMode.SINGLE
      };
    case AbSelectionMode.MULTIPLE:
      return {
        ...props,
        selectionMode: SelectionMode.MULTIPLE
      };
  }
};
//# sourceMappingURL=AbList.js.map
